<template>
    <div class="jump-order nav-bar-fixed">
        <van-nav-bar title="对账单详情" left-arrow fixed @click-left="back"/>
        <van-cell title="基本信息" class="bill-title"/>
        <div class="bill-item">
            <van-cell class="bill-state">
                <p slot="title">牧场名称 <span>{{baseList.mcmc}}</span></p>
            </van-cell>
            <van-cell title="牧场编号" :value="baseList.pasture_id"/>
            <van-cell title="月结时间" :value="baseList.billingMonth"/>
            <van-cell title="确认时间" :value="baseList.confirm_time"/>
            <van-cell title="状态" :value="baseList.confirm_status==1?'待确认':baseList.confirm_status==2?'已确认':'已驳回'"
                      class="bill-state"/>
        </div>
        <div class="bill-item">
            <van-cell title="单位" :value="baseList.nuit" class="bill-state"/>
            <van-cell title="上次欠款金额" :value="baseList.last_month_arrear"/>
            <van-cell title="本月销售金额" :value="baseList.sales_amount"/>
            <van-cell title="本月已还款金额" :value="baseList.this_month_return"/>
            <van-cell title="累计欠款金额" :value="baseList.this_month_arrear"/>
            <van-cell title="状态"
                      :value="baseList.pay_status=='0'?'待还款':baseList.pay_status==false?'待还款':baseList.pay_status=='1'?'已还款':baseList.pay_status==true?'已还款':''"
                      class="bill-state"/>
        </div>
        <div class="bill-item">
            <van-cell title="累计欠款已还款金额" :value="baseList.paid_amount"/>
            <van-cell title="累计欠款待还款金额" :value="baseList.generation_also_amount"/>
            <van-cell title="累计欠款还款待审核金额" :value="baseList.confirmed_amount"/>
        </div>
        <div class="bill-item" v-for="item in sellList">
            <van-cell title="序号" :value="item.id" class="bill-state"/>
            <van-cell title="商品名" :value="item.goods_name"/>
            <van-cell title="数量" :value="item.count"/>
            <van-cell title="金额" :value="item.price"/>
            <van-cell title="备注" :value="item.remark"/>

        </div>
        <div class="bill-item">
            <van-cell title="合计" :value="totalPrice" class="bill-state"/>
        </div>
        <van-row v-if="baseList.confirm_status==1">
            <span style="margin-left: 15px">备注</span>
            <van-field type="textarea" v-model="remark"/>
        </van-row>

        <van-row v-if="baseList.confirm_status==1">

            <van-col span="8" style="margin: 10px">
                <van-button type="info" size="normal" @click="saveUpdate(2)">确认</van-button>
            </van-col>
            <van-col span="8" style="margin: 10px">
                <van-button type="info" size="normal" style="background-color: #ffc107; border-color: #ffc107;" @click="saveUpdate(3)">驳回</van-button>
            </van-col>
        </van-row>

        <van-row style="padding:10px 0;text-align:center;">
            <van-col span="10" style="margin: 10px" v-if="data.unionpayIsShow">
            <van-button type="info" size="normal" @click="payOrder(1)">银联快捷支付</van-button>
            </van-col>
            <van-col span="10" style="margin: 10px">
                <van-button type="info" size="normal" @click="payOrder(2)" v-if="data.unLinePayIsShow">线下支付</van-button>
            </van-col>
        </van-row>

    </div>
</template>
<script>
    import {NavBar, Cell, Button, Row,Field,Col } from "vant";

    export default {
        name: "userBillDetail",
        components: {
            [Col.name]: Col,
            [Field.name]: Field,
            [Row.name]: Row,
            [Button.name]: Button,
            [NavBar.name]: NavBar,
            [Cell.name]: Cell
        },
        data() {
            return {
                id: this.$route.query.id,
                baseList: {},
                sellList: [],
                totalPrice: 0,
                data: {},
                remark:'',
                remarkStatus:false
            };
        }, mounted: function () {
            this.milkImportConfirm()
        },
        methods: {
            back() {
                history.back();
            }, milkImportConfirm() {
                let that = this
                that.$api.post(
                    that.jumuc.userCenter.milkImportConfirm,
                    {
                        "milkConfirmId": that.id
                    },
                    successRes => {
                        that.data = successRes.data
                        that.baseList = successRes.data.baseList[0]
                        that.sellList = successRes.data.sellList
                        for (var i = 0; i < that.sellList.length; i++) {
                            that.totalPrice = that.totalPrice + that.sellList[i].price
                        }
                    })
            }, saveUpdate(status) {
                let that = this
                that.$api.post(
                    that.jumuc.userCenter.milkImComfirmDeal,
                    {
                        "remark": that.remark,
                        "status": status,
                        "milkConfirmId": that.$route.query.id
                    },
                    successRes => {
                        that.$toast(successRes.msg);
                        if (successRes.success) {
                            location.reload()
                        }
                    })
            }, payOrder(type) {
                let that = this
                if (type == 1) {
                    location.href = "#/order/billpay?id=" + that.id
                } else if (type == 2) {
                    //线下
                    location.href = "#/order/billoffline?id=" + that.id
                }
            }
        }
    };
</script>
<style lang="less" scoped>
    @bule-thame: #3c6eeb;
    body {
        background-color: #f7f7f7;
    }

    .jump-order {

    }

    .bill-title {
        color: @bule-thame;
        font-size: 16px;
    }

    .bill-item {
        margin-top: 5px;
        .bill-state {
            p span {
                color: @bule-thame;
                margin-left: 5px;
            }
            .van-cell__value span {
                color: @bule-thame;
            }
        }
    }

    .van-cell:not(:last-child)::after {
        border-width: 0;
    }
</style>


